import capitalize from 'lodash/capitalize';
import { track } from '@fff-web/fff-analytics';
import type { IUser } from '@fff-web/fff-utilities';
import { getPlanChangeCompletedEventStatusFromResponse } from '../../helpers';
import {
  REACTIVATION_COMPLETED_EVENT,
  REACTIVATION_COMPLETED_EVENT_TYPE,
  REACTIVATION_EXPERIENCE,
} from '../../pages/constants';

export const trackReactivation = ({
  response,
  user,
}: {
  response: Response | void;
  user: IUser;
}) => {
  const subscriptionType = user.subscriptionType.toLowerCase();
  const reactivationType = `Canceled ${capitalize(subscriptionType)}`;
  const status = getPlanChangeCompletedEventStatusFromResponse(response);

  track({
    trackName: REACTIVATION_COMPLETED_EVENT,
    properties: {
      cta_name: 'Reactivate Now',
      type: REACTIVATION_COMPLETED_EVENT_TYPE,
      experience: REACTIVATION_EXPERIENCE,
      reactivation_type: reactivationType,
      status,
    },
  });
};
